import { Slide } from '@/components/core/Slide';
import ElevenLabsWidget from '@/components/integrations/ElevenLabsWidget';

export const slide = () => {
  return (
    <Slide notes="Live agent" networkBackground="full">
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2"
        style={{ width: '300px', height: '1px' }}
      >
        <ElevenLabsWidget
          agentId="L2pa6z5s0YvZI28IB8az"
          variant="compact"
          style={{ transform: 'scale(2)' }}
        />
      </div>
    </Slide>
  );
};
